/* eslint-disable  */

import React from "react"
import { ImBin2 } from "react-icons/im"
import { BiPhone } from "react-icons/bi"
import { Link } from "@reach/router"
import { FaPencilAlt, FaPlus } from "react-icons/fa"
import useAuth from "../../../hooks/useAuth"
import useAxiosPrivate from "../../../hooks/useAxiosPrivate"
import { useLocation } from "@reach/router"

interface Props extends Address {
  getShippingAddress: () => void
}

const AddressCard = ({
  formatted,
  phone,
  id,
  address1,
  defaultAddress,
  getShippingAddress,
  name,
}: Props) => {
  const { auth } = useAuth()
  const location = useLocation()

  const privateAxios = useAxiosPrivate()

  const deleteMessage = async () => {
    await privateAxios
      .post("/.netlify/functions/delete-address", {
        id,
      })
      .then(result => {
        if (result.data.id) {
          getShippingAddress()
        }
      })
      .catch(err => {
        console.error(err)
      })
  }
  return (
    <div className="lg:max-w-[350px] w-full bg-white py-6 px-5 relative lg:mr-4">
      {defaultAddress && (
        <button className="absolute top-4 left-4 text-white rounded-tl-md rounded-br-md bg-[#C99E1A] px-3 pt-1 flex justify-center items-center font-expanded font-semibold">
          Default
        </button>
      )}
      <button onClick={deleteMessage} className="absolute top-6 right-4">
        <ImBin2 />
      </button>
      <div className="mt-8">
        <h1 className="mb-0 font-extrabold text-base">
          {name || `${auth?.firstName} ${auth?.lastName}`}
        </h1>
        <p className="mb-0 font-normal text-sm">{formatted?.[1]}</p>
        <p className="mb-0 font-normal text-sm">{formatted?.[0] || address1}</p>
        <div className="flex items-center mt-3">
          <BiPhone size={24} />
          <p className="mb-0 text-sm ml-3">{phone}</p>
        </div>
        <Link
          to={`/account/shipping-address/update?id=${id}/${
            location.search ? location.search : ""
          }`}
          className="mb-0 mt-4 flex items-center border-2 border-gray-800 max-w-[180px]"
        >
          <p className="mb-0 border-r-2 border-gray-800 m-0 px-10 py-2 text-lg leading-8 font-bold">
            Edit
          </p>
          <div className="px-3 mb-0 h-full flex justify-center items-center">
            <FaPencilAlt />
          </div>
        </Link>
      </div>
    </div>
  )
}

export default AddressCard
